module.exports = __webpack_public_path__ + "static/hero-b649df139637270ff70382d49371a355.png";